import { render, staticRenderFns } from "./ProductGroupStat.vue?vue&type=template&id=5462088e&lang=pug&"
import script from "./ProductGroupStat.vue?vue&type=script&lang=js&"
export * from "./ProductGroupStat.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports